import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';

import { Grid } from '@xsolla/ui-core';

import { usePaths } from '../../../routes/routesHelper';
import { RouteParams } from '../../../routes/types';
import { EmailIcon, SMSIcon, ToggleBox } from '../../ui';
import NavigationSettingsLink from '../NavigationSettingsLink';

const ProvidersSettings = ({ match }: RouteComponentProps): JSX.Element => {
  const { emailCustomProviderPath, smsCustomProviderPath } = usePaths();
  const { projectId } = match.params as RouteParams;
  const intl = useIntl();
  return (
    <>
      <ToggleBox
        title={intl.messages['navigation.settings.custom-providers.label']}
        openByDefault
        dataTestId="navigation-block-providers">
        <Grid cols={2} gap={24}>
          <NavigationSettingsLink
            dataTestId="link-navigation-email-provider"
            icon={<EmailIcon />}
            titleInfo={{
              label: intl.messages['navigation.settings.custom-providers.email.title'],
              path: emailCustomProviderPath(projectId)
            }}
            subtitle={intl.messages['navigation.settings.custom-providers.email.subtitle']}
          />
          <NavigationSettingsLink
            dataTestId="link-navigation-sms-provider"
            icon={<SMSIcon />}
            titleInfo={{
              label: intl.messages['navigation.settings.custom-providers.sms.title'],
              path: smsCustomProviderPath(projectId)
            }}
            subtitle={intl.messages['navigation.settings.custom-providers.sms.subtitle']}
          />
        </Grid>
      </ToggleBox>
    </>
  );
};

export default withRouter(ProvidersSettings);
